import type { ReactNode } from 'react'
import { cx } from '../cx'

export interface EmptyStateProps {
  readonly title: string
  readonly description?: string
  /** A single call to action; more than one turns an empty state into a menu. */
  readonly action?: ReactNode
  readonly className?: string
}

/** What a list renders instead of nothing, so "empty" never reads as "broken". */
export function EmptyState({ title, description, action, className }: EmptyStateProps) {
  return (
    <div
      className={cx(
        'flex flex-col items-center gap-2 rounded-card border border-line border-dashed px-6 py-10 text-center',
        className,
      )}
    >
      <p className="font-medium text-ink text-lead">{title}</p>
      {description === undefined ? null : (
        <p className="max-w-prose text-body text-muted">{description}</p>
      )}
      {action === undefined ? null : <div className="mt-2">{action}</div>}
    </div>
  )
}
